import Chart from "react-apexcharts";

const FileCountDonutChart = () => {
  const fileCounts = {
    Images: 325,
    Videos: 150,
    Audio: 280,
    Documents: 100,
    Others: 70,
  };

  const labels = Object.keys(fileCounts);
  const series = Object.values(fileCounts);
  const totalCount = series.reduce((sum, val) => sum + val, 0);

  const colors = [
    "#f87171",
    "#c084fc",
    "#34d399",
    "#60a5fa",
    "#fbbf24",
    "#9ca3af",
  ];

  const options = {
    chart: {
      type: "donut",
    },
    labels,
    colors,
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} files`,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            name: {
              show: false,
            },
            value: {
              show: true,
              fontSize: "24px",
              fontWeight: 600,
              color: "#111",
              offsetY: 6,
              formatter: () => `${totalCount} Files`,
            },
            total: {
              show: true,
              label: "Total",
              fontSize: "14px",
              color: "#666",
              formatter: () => `${totalCount} Files`,
            },
          },
        },
      },
    },
  };

  return (
    <div className="flex flex-col items-center gap-6 p-6 rounded-lg">
      <div className="w-full max-w-md">
        <Chart options={options} series={series} type="donut" width="100%" />
      </div>

      <div className="w-full max-w-md grid grid-cols-2 sm:grid-cols-3 gap-4 text-sm text-gray-700">
        {labels.map((label, index) => (
          <div
            key={label}
            className="flex items-start gap-2 p-1"
          >
            <span
              className="w-3 h-3 rounded-full mt-1 shrink-0"
              style={{ backgroundColor: colors[index] }}
            ></span>
            <div>
              <div className="font-medium text-gray-900 text-xs">{label}</div>
              <div className="text-xs text-gray-500">
                {fileCounts[label]} files
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileCountDonutChart;
